import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, TemplateRef, inject } from '@angular/core';

import { ComponentAbstract } from '@app/components/abstract/component.abstract';

@Component({
  selector: 'app-read-only-field',
  templateUrl: './read-only-field.component.html',
  styleUrls: ['./read-only-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReadOnlyFieldComponent extends ComponentAbstract {
  protected cdr: ChangeDetectorRef = inject(ChangeDetectorRef);

  @Input() containerCss = 'display-flex flex-column';
  @Input() label = '';
  @Input() labelCss = 'nowrap body-small-bold';
  @Input() declare value: unknown;
  @Input() emptyValue = '–';
  @Input() valueContainerCss = 'value-container h-40';
  @Input() valueCss = 'ellipsis body-small text-color dark';
  @Input() declare customValue: TemplateRef<any>;
  @Input() hasFade = false;

  constructor() {
    super(inject(ChangeDetectorRef));
  }
}
